/**
 * Component: Spinner
 *
 * Description:
 * A simple full-screen spinner loader component.
 * This is used to indicate loading or processing states in the UI.
 *
 * Usage:
 * - Import and include <Spinner /> anywhere you need a full-page loader.
 * - Styles are defined separately in 'Spinner.css'.
 *
 * Note:
 * - If using the pulse loader variant, ensure `.spinner-container.loader` is used in the markup.
 */

import React from 'react';
import './Spinner.css'; // Contains styles for overlay and spinner visuals

const Spinner = () => {
  return (
    <div className="spinner-overlay">
      {/* You can optionally add `loader` class here if using the pulse loader variant */}
      <div className="spinner-container"></div>
    </div>
  );
};

export default Spinner;
